import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { Button } from '../Button'
import { omit } from '../../lib/ramda'

const ButtonLink = styled(Button)`
  border: 0;
  outline: none;
  background: none;
  width: auto;
  padding: 0;
  text-decoration: none;
  color: ${STYLES.PRIMARY_COLOR};
  &:hover {
    background: none;
    color: ${STYLES.LINK_HOVER_COLOR};
    text-decoration: underline;
    &:disabled {
      text-decoration: none;
    }
  }
`

const LinkStyle = `
  text-decoration: none;
  color: ${STYLES.PRIMARY_COLOR};
  &:hover {
    color: ${STYLES.LINK_HOVER_COLOR};
    text-decoration: underline;
    &:disabled {
      text-decoration: none;
    }
  }
`

const StyledGatsbyLink = styled(GatsbyLink)`
  ${LinkStyle}
`

const AnchorLink = styled.a`
  ${LinkStyle}
`

interface ILinkProps {
  to?: string
  onClick?: () => void
  children: React.ReactNode
  className?: string
  title?: string
  style?: React.CSSProperties
  onMouseOver?: () => void
  onMouseLeave?: () => void
  disabled?: boolean
}

const Link: React.FC<ILinkProps> = (props) => {
  const {
    to,
    children,
    className,
    onClick,
    title,
    style,
    onMouseOver,
    onMouseLeave,
  } = props
  if (to) {
    if (/^http(s)*:\/\//.test(to) || /^mailto/.test(to)) {
      return (
        <AnchorLink
          title={title}
          onClick={onClick}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          className={className}
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          style={style}
        >
          {children}
        </AnchorLink>
      )
    }
    return <StyledGatsbyLink title={title} {...omit(['active'], props)} />
  }
  return <ButtonLink type="button" {...props} />
}

export { Link }
